// src/pages/SignIn/SignIn.js

import React, { useEffect, useRef } from "react";
import MicrosoftButton from "../../../Auth/AuthMicrosoft/MicrosoftButton"; // Importa il pulsante Microsoft

const FormSignIn = () => {
  const focusRef = useRef(null);

  useEffect(() => {
    // Recenter the page on the sign-in callout (below sticky header).
    const el = focusRef.current;
    if (!el) return;

    // Wait a tick so layout (image/columns) is measured correctly.
    const id = window.setTimeout(() => {
      const headerOffset = 120; // approx. sticky header height
      const rect = el.getBoundingClientRect();
      const top = rect.top + window.scrollY - headerOffset;
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }, 50);

    return () => window.clearTimeout(id);
  }, []);

  return (
    <div className="form-content-right">
      <div ref={focusRef} className="form" style={{ textAlign: "center" }}>
        <h1 className="SignUpInTitle">Bentornato!</h1>
        <h1 className="text-center sm:text-left">Pronto per accedere all'area riservata?</h1>
        <div className="mt-4" style={{ textAlign: "center" }}>
          <MicrosoftButton /> {/* Mostra il pulsante Microsoft qui */}
        </div>
      </div>
    </div>
  );
};

export default FormSignIn;
